class Events{
    init(){
        let _this = this;
        this.eventVisu();
        this.eventGallery();
        this.navTop();
        this.eventOrientation();
        $(window).scroll(function() {
            _this.navTopScroll();
        });
    }

    eventOrientation() {
        $(window).on("orientationchange", function() {
            $('.sliderFor').css("display", "none");
            setTimeout(function() {
                $('.sliderFor').css("display", "initial");
            }, 100);
            setTimeout(function() {
                $('.sliderFor').slick('setPosition');
                $('.sliderFor').css("display", "initial");
            }, 400);
            setTimeout(function() {
                $('.sliderFor').slick('setPosition');
            }, 1200);
        });
    }

    eventVisu() {
        $('header .visu').addClass('on')
    }

    eventGallery() {

        $('#galerie .sliderNav a').each(function(){
            var myElt = $(this).attr('href');
            var myEltExt = $(this).attr('href').split(".");
            var myEltImg = $(this).find('img').attr('src');
            var myEltImgBig = myEltImg.split("-320x166")[0] + myEltImg.split("-320x166")[1];

            myEltExt = myEltExt[(myEltExt.length-1)];

            if (myEltImg.split("-320x166")[1] == '.gif'){
                $(this).find('img').attr('src', myEltImgBig)
            }

            if (myEltExt == 'mp4'){
                myElt = '<div><i class="fi flaticon-play btn"></i><video autobuffer poster="' + myEltImgBig + '"><source src="' + myElt + '" type="video/mp4"></video></div>';
                $(this).addClass('fi flaticon-play video')
            }else{
                myElt = '<div><img src="' + myElt + '" alt="" /></div>' ;
            }


            $(myElt).appendTo('#galerie .sliderFor');
        });
        $('#galerie .sliderNav a').click(function(e){
            e.preventDefault();
        });
        $('#photo').find('.banner,.banner button').click(function(){
            $("#galerie").css({'visibility':'visible', 'display':'none', 'z-index':'9999'});
            $("#galerie").fadeIn(800);
            $('body').css('overflow', 'hidden');
        });
        $('#galerie .close').click(function(){
            $("#galerie").fadeOut(800);
            $('body').css('overflow', 'auto');
        });

        $('#galerie .sliderFor').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            asNavFor: '#galerie .sliderNav p'
        });

        $('#galerie .sliderNav p').slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            infinite: true,
            centermode: true,
            asNavFor: '#galerie .sliderFor',
            dots: false,
            arrows : false,
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        });

        $('#galerie .sliderFor').on('beforeChange', function(event, slick, currentSlide, nextSlide){
            var myCurrentSlide = currentSlide + 1
            var myVideo = $('#galerie .sliderFor .slick-slide:nth-child('+ myCurrentSlide +')').find('video');
            if(myVideo.length){
                myVideo[0].pause();
                myVideo.parent().removeClass('play');
            }
        });
        $('#galerie .sliderFor').on('afterChange', function(event, slick, currentSlide, nextSlide){
            /*var myCurrentSlide = currentSlide + 1
             var myVideo = $('#galerie .sliderFor span:nth-child('+ myCurrentSlide +')').find('video');
             console.log(myVideo.html());
             if(myVideo.length){
             console.log('je passe');
             myVideo[0].play();
             }*/
        });
        $('#galerie .sliderFor .btn').click(function(){
            $(this).parent().addClass('play');
            $(this).parent().find('video')[0].play();
        });
        $('#galerie .close').click(function(){
            $('#galerie .slick-slide.play').each(function(){
                $(this).removeClass('play');
                $(this).find('video')[0].pause();
            });
        });
        $('#galerie .sliderFor video').click(function(){
            if ($(this).parent().hasClass('play')){
                $(this)[0].pause();
            }else{
                $(this)[0].play();
            }
            $(this).parent().toggleClass('play');
        });

    }

    navTop(){
        this.navTopScroll();
        $('.navTop').click(function(){
            $('html, body').animate({
                scrollTop:0
            }, 'slow');
            return false;
        });
    }

    navTopScroll(){
        if ($(window).scrollTop() <= ($('header .visu').height() - 75)){
            $('.navTop').addClass('off')
        } else  {

            $('.navTop').removeClass('off')
        }
    }
}

export default Events;
